/* eslint-disable max-len */
import React from 'react';

import { GridLegacy as Grid } from '@mui/material';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { AxiosResponse } from 'axios';

import FieldHelpIcon from 'components/FieldHelpIcon';

import api from 'utils/api';

import Logger from 'utils/logger';

import {
  TaskRecordContainer,
  TaskRecordRow,
  RecordRow,
  FirstColumn,
  SecondColumn,
  Title,
  HeaderGrid,
  RedirectButton,
} from './styles';

const HELP_TEXT =
  'Contains key terms and conditions for using Vatix products. Click for details on your current agreement version.';

const DEFAULT_MASTER_SERVICE_AGREEMENT = {
  name: 'View agreement',
  url: 'https://www.vatix.com/legal/master-service-agreement',
};

const MasterServiceAgreement: React.FunctionComponent = (): React.ReactElement => {
  const [masterServiceAgreement, setMasterServiceAgreement] = React.useState<{
    name: string;
    url: string;
  }>();

  React.useEffect(() => {
    const loadMasterServiceAgreement = (): void => {
      api.organisations
        .loadMasterServiceAgreement()()
        .then((response: AxiosResponse) => {
          setMasterServiceAgreement(response.data);
        })
        .catch((error: Error) => {
          Logger.error('Invalid load master service agreement API response', error);
        });
    };

    loadMasterServiceAgreement();
  }, []);

  return (
    <>
      <HeaderGrid container alignItems="center" marginTop="10px">
        <Grid item xs={12} container alignContent="flex-start">
          <Title>Master Service Agreement</Title>
        </Grid>
      </HeaderGrid>
      <TaskRecordContainer>
        <TaskRecordRow>
          <RecordRow>
            <FirstColumn>
              Master Service Agreement
              <FieldHelpIcon name="Master Service Agreement" helpText={HELP_TEXT} />
            </FirstColumn>
            <SecondColumn>
              <RedirectButton
                size="small"
                variant="text"
                onClick={() =>
                  masterServiceAgreement
                    ? window.open(masterServiceAgreement.url)
                    : window.open(DEFAULT_MASTER_SERVICE_AGREEMENT.url)
                }
              >
                {masterServiceAgreement ? masterServiceAgreement.name : DEFAULT_MASTER_SERVICE_AGREEMENT.name}
                <OpenInNewIcon sx={{ width: 15, height: 15, marginLeft: '8px' }} />
              </RedirectButton>
            </SecondColumn>
          </RecordRow>
        </TaskRecordRow>
      </TaskRecordContainer>
    </>
  );
};
export default MasterServiceAgreement;
